module.exports = __webpack_public_path__ + "img/jianjie2.c7633c5a.jpg";